export default {
    getStudent() {
      return axios.post('/student')
    },
    login(credentials) {
      return axios.post(`/checkout/login`, credentials)
    },
    register(credentials) {
      return axios.post(`/checkout/register`, credentials)
    },
    storeComment(lectureId, comment) {
      return axios.post(`/lecture/${lectureId}/comment`, comment)
    },
    removeComment(commentId) {
      return axios.delete(`/comment/${commentId}/remove`)
    },
    fetchLecture(lectureId) {
      return axios.post(`/lecture/${lectureId}/watch`)
    },
    editNote(lectureId, note) {
      return axios.post(`/lecture/${lectureId}/notes`, { note })
    },
    starLecture(lectureId, note) {
      return axios.post(`/lecture/${lectureId}/star`)
    },  
  }
  